import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";
import SouAnimations from "./animations/SouAnimations";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockImageGrid from "./blocks/BlockImageGrid";
import BlockSliderMultiple from "./blocks/BlockSliderMultiple";
import BlockSliderSimple from "./blocks/BlockSliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSliderImageBackgroundText from "./blocks/BlockSliderImageBackgroundText";
import BlockSliderMultipleText from "./blocks/BlockSliderMultipleText";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();
	new SouAnimations();

	// Blocks
	new BlockBanner();
	new BlockCollapse();
	new BlockImageGrid();
	new BlockMap();
	new BlockQuotes();
	new BlockSliderImageBackgroundText();
	new BlockSliderSimple();
	new BlockSliderMultiple();
	new BlockSliderMultipleText();
});

window.initMap = function () {
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};
